"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash.keyby"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// eslint-disable-next-line lodash/import-scope

var foodhubs = [{
  name: 'LA Foodhub',
  slug: 'la',
  tzid: 'America/Los_Angeles',
  isActive: false,
  isFulfillmentCenter: true,
  isProductionCenter: false,
  location: {
    name: 'Good Eggs',
    address: '2760 Clearwater St.',
    address2: null,
    city: 'Los Angeles',
    state: 'CA',
    zip: '90039'
  }
}, {
  name: 'Rankin Fulfillment Center',
  slug: 'sfbay',
  // Ideally this would be changed because this no longer makes sense but it doesn't appear to be worth the effort.
  tzid: 'America/Los_Angeles',
  isActive: false,
  isFulfillmentCenter: true,
  isProductionCenter: false,
  location: {
    name: 'Good Eggs HQ',
    address: '901 Rankin St',
    address2: null,
    city: 'San Francisco',
    state: 'CA',
    zip: '94124'
  }
}, {
  name: 'NOLA Foodhub',
  slug: 'nola',
  tzid: 'America/Chicago',
  isActive: false,
  isFulfillmentCenter: true,
  isProductionCenter: false,
  location: {
    name: 'Good Eggs Office',
    address: '4040 Euphrosine St.',
    address2: null,
    city: 'New Orleans',
    state: 'LA',
    zip: '70125'
  }
}, {
  name: 'NYC Foodhub',
  slug: 'nyc',
  tzid: 'America/New_York',
  isActive: false,
  isFulfillmentCenter: true,
  isProductionCenter: false,
  location: {
    name: 'Good Eggs',
    address: '365 Ten Eyck St.',
    address2: null,
    city: 'Brooklyn',
    state: 'NY',
    zip: '11206'
  }
}, {
  name: 'Maritime Fulfillment Center',
  slug: 'MAR1',
  tzid: 'America/Los_Angeles',
  isActive: true,
  isFulfillmentCenter: true,
  isProductionCenter: false,
  location: {
    name: 'Good Eggs',
    address: '2000 Maritime St.',
    address2: 'Bldg 2',
    city: 'Oakland',
    state: 'CA',
    zip: '94607'
  }
}, {
  name: 'Vernon Fulfillment Center',
  slug: 'VRN1',
  tzid: 'America/Los_Angeles',
  isActive: false,
  isFulfillmentCenter: true,
  isProductionCenter: false,
  location: {
    name: 'Good Eggs',
    address: '2080 East 49th Street',
    address2: null,
    city: 'Vernon',
    state: 'CA',
    zip: '90058'
  }
}, {
  name: 'Oakland Kitchen',
  slug: 'OKN2',
  tzid: 'America/Los_Angeles',
  isActive: true,
  isFulfillmentCenter: false,
  isProductionCenter: true,
  location: {
    name: 'Good Eggs Kitchen',
    address: '985 3rd St.',
    address2: 'Unit B',
    city: 'Oakland',
    state: 'CA',
    zip: '94607'
  }
}];
var allActive = foodhubs.filter(function (foodhub) {
  return foodhub.isActive;
});
var allInactive = foodhubs.filter(function (foodhub) {
  return !foodhub.isActive;
});
var _activeFoodhubsBySlug = (0, _lodash.default)(allActive, function (foodhub) {
  return foodhub.slug;
});
var _allFoodhubsBySlug = (0, _lodash.default)(foodhubs, function (foodhub) {
  return foodhub.slug;
});
var activeFoodhubSlugs = Object.keys(_activeFoodhubsBySlug);
var inactiveFoodhubSlugs = allInactive.map(function (foodhub) {
  return foodhub.slug;
});
var bySlug = function bySlug(slug) {
  var foodhub = _allFoodhubsBySlug[slug];
  return foodhub != null ? foodhub : null;
};
var _default = {
  foodhubSlugs: activeFoodhubSlugs,
  inactiveFoodhubSlugs: inactiveFoodhubSlugs,
  all: allActive,
  bySlug: bySlug
};
exports.default = _default;
//# sourceMappingURL=index.js.map